/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Columns_StatusInputs */

const id_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keadaan`)
};

const ms_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keadaan`)
};

const da_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilstand`)
};

const de_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustand`)
};

const en_us2_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_es2_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const es_mx2_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fil_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalagayan`)
};

const fr_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const it_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const hu_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Állapot`)
};

const nl_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestand`)
};

const no_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilstand`)
};

const pl_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stan`)
};

const pt_br2_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const pt_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const ro_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stare`)
};

const fi_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tila`)
};

const sv_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillstånd`)
};

const vi_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

const tr_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

const cs_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const bg_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Състояние`)
};

const ru_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const uk_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стан`)
};

const ar_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة`)
};

const hi_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const th_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานะ`)
};

const ja_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ステータス`)
};

const zh_cn2_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

const zh_hant1_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狀態`)
};

const ko_builds_comparison_columns_status = /** @type {(inputs: Builds_Comparison_Columns_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상태`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Builds_Comparison_Columns_StatusInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_columns_status = /** @type {((inputs?: Builds_Comparison_Columns_StatusInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Columns_StatusInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_columns_status(inputs)
	if (locale === "ms") return ms_builds_comparison_columns_status(inputs)
	if (locale === "da") return da_builds_comparison_columns_status(inputs)
	if (locale === "de") return de_builds_comparison_columns_status(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_columns_status(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_columns_status(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_columns_status(inputs)
	if (locale === "fil") return fil_builds_comparison_columns_status(inputs)
	if (locale === "fr") return fr_builds_comparison_columns_status(inputs)
	if (locale === "it") return it_builds_comparison_columns_status(inputs)
	if (locale === "hu") return hu_builds_comparison_columns_status(inputs)
	if (locale === "nl") return nl_builds_comparison_columns_status(inputs)
	if (locale === "no") return no_builds_comparison_columns_status(inputs)
	if (locale === "pl") return pl_builds_comparison_columns_status(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_columns_status(inputs)
	if (locale === "pt") return pt_builds_comparison_columns_status(inputs)
	if (locale === "ro") return ro_builds_comparison_columns_status(inputs)
	if (locale === "fi") return fi_builds_comparison_columns_status(inputs)
	if (locale === "sv") return sv_builds_comparison_columns_status(inputs)
	if (locale === "vi") return vi_builds_comparison_columns_status(inputs)
	if (locale === "tr") return tr_builds_comparison_columns_status(inputs)
	if (locale === "cs") return cs_builds_comparison_columns_status(inputs)
	if (locale === "bg") return bg_builds_comparison_columns_status(inputs)
	if (locale === "ru") return ru_builds_comparison_columns_status(inputs)
	if (locale === "uk") return uk_builds_comparison_columns_status(inputs)
	if (locale === "ar") return ar_builds_comparison_columns_status(inputs)
	if (locale === "hi") return hi_builds_comparison_columns_status(inputs)
	if (locale === "th") return th_builds_comparison_columns_status(inputs)
	if (locale === "ja") return ja_builds_comparison_columns_status(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_columns_status(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_columns_status(inputs)
	return ko_builds_comparison_columns_status(inputs)
});
export { builds_comparison_columns_status as "builds.comparison.columns.status" }